import { identity, keys, map, pickBy } from 'lodash';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, HostListener, ChangeDetectorRef, OnDestroy, Renderer2, Inject, PLATFORM_ID } from '@angular/core';

import { CatalogueCategoryType, InternalProductWithRatingsWithFavoriteStatusType } from '@sifca-monorepo/ecommerce-generator';

import { catchError, combineLatest, of, take } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AppService, SeoService, SharedService, UtilsService } from '../../services';

declare const FB: any;

@Component({
  template: '',
})
export class BaseAllProductsListComponent implements OnInit, OnDestroy {
  seo: any;
  params: any;
  type = null;
  totalCount = 0;
  toggle = false;
  loaded = false;
  urlKey: string;
  categorySeo: any;
  categoryUrl: any;
  firstLoad = false;
  posId: string = '';
  pagesToBeShown = [];
  currentCategory: string;
  category: CatalogueCategoryType;
  filtredProducts: InternalProductWithRatingsWithFavoriteStatusType[];
  constructor(
    protected router: Router,
    protected renderer: Renderer2,
    protected metaTagService: Meta,
    protected appService: AppService,
    protected sharedService: SharedService,
    protected titleTagService: Title,
    protected seoService: SeoService,
    protected utilsService: UtilsService,
    protected activeRoute: ActivatedRoute,
    protected changeDetectorRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected platformId: Object,
    @Inject(DOCUMENT) protected document: Document,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    this.appService.fromPrice = null;
    this.appService.toPrice = null;
    this.activeRoute.queryParams.subscribe((params) => {
      this.params = params;
      if (keys(params).length && !params['page']) {
        this.router.navigateByUrl('/shop');
      }
      if (params['page']) {
        this.refresh();
      }
    });
    this.activeRoute.params.subscribe((params) => {
      this.categoryUrl = params['categoryUrl'];
      this.urlKey = params['categoryUrl'];
      this.appService
        .getCategoryByUrl(params['categoryUrl'])
        .pipe(
          catchError(() => {
            return of(null);
          }),
        )
        .subscribe((result) => {
          this.category = result;
          this.currentCategory = result?.name;
          this.appService.selectedCategories = [result.id];
          this.categorySeo = result.seo;
          this.sharedService.tags$ = this.metaTagService.addTags([
            { charset: 'UTF-8' },
            ...(this.categorySeo?.metaDesription ? [{ name: 'description', content: this.categorySeo?.metaDesription }] : []),
            { name: 'metaTitle', content: this.categorySeo?.metaTitle },
            { name: 'urlKey', content: this.categorySeo?.urlKey },
          ]);
          combineLatest([this.seoService.getMainCategorySEOJSON(result.id), this.sharedService.tags$])
            .pipe(
              take(1),
              catchError((e) => {
                return of(null);
              }),
            )
            .subscribe(([res, tags]) => {
              this.seo = res;
              if (this.seo?.title) {
                this.titleTagService.setTitle(this.seo?.title);
              }
              this.sharedService.tags$ = [...tags, ...this.metaTagService.addTags(map(this.seo?.metas, (meta) => pickBy(meta, identity)))];
                this.sharedService.links$ = map(this.seo?.links, (seoLink) => {
                  const link = this.renderer.createElement('link');
                  if (seoLink.sizes) {
                    link.sizes = seoLink.sizes;
                  }
                  if (seoLink.href) {
                    link.href = seoLink.href;
                  }
                  if (seoLink.rel) {
                    link.rel = seoLink.rel;
                  }
                  this.renderer.appendChild(this.document.head, link);
                  return link;
                });
            });
          if (!this.params?.page) {
            this.refresh();
          }
        });
      this.type = params['type'];
      if (!this.type) {
        this.type = '4cols'
      }
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // if (window.innerWidth > 991) {
      //   this.toggle = false;
      // } else {
      //   this.toggle = true;
      // }
    }
    this.appService.filtredProducts$.subscribe((paginateResponse: any) => {
      this.loaded = false;
      if (paginateResponse) {
        this.filtredProducts = paginateResponse.objects;
        if (!this.firstLoad) {
          this.firstLoad = true;
        }
        this.loaded = true;
        this.totalCount = paginateResponse.count;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  refresh() {
    this.appService.productsPageIndex$ = this.params?.page - 1 || 0;
    this.appService
      .getSimpleProductsWithRatingsWithFavoriteStatusWithFilter()
      .pipe(
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe();
  }

  @HostListener('window: resize', ['$event'])
  onResize(event: Event) {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth > 991) {
        this.toggle = false;
      } else {
        this.toggle = true;
      }
    }
  }

  changeOrderBy(event: any) {
    this.router.navigate([], { queryParams: { orderBy: event.currentTarget.value, page: 1 }, queryParamsHandling: 'merge' });
  }

  sortBy(event: any) {
    this.filtredProducts = null;
    this.loaded = false;
    this.appService.createdAtSort = null;
    this.appService.nameSort = null;
    this.appService.priceSort = null;
    if (event) {
      event = JSON.parse(event.target.value);
      this.appService[event.field] = event.value;
    }
    this.appService
      .getSimpleProductsWithRatingsWithFavoriteStatusWithFilter()
      .pipe(
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe((res) => {
        if (res) {
          this.loaded = true;
          this.utilsService.scrollToPageContent();
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  shareOnFacebook() {
    if (isPlatformBrowser(this.platformId)) {
      FB.ui({
        method: 'share',
        href: `https://cocospacio.com/c/${this.categoryUrl}`,
        // href: `${window.location.href}/c/${this.categoryUrl}`,
      }, (response) => {
        if (response && !response.error_code) {
          // The user successfully shared the product on Facebook
          console.log('Shared successfully');
          // You can trigger any additional actions here
        } else {
          // There was an error or the user canceled the share
          console.error('Share error');
        }
      });
    }
  }

  ngOnDestroy() {
    this.filtredProducts = null;
    this.appService.filtredProducts$ = null;
  }
}
